import { useCallback, useRef } from 'react'
import { useResizeObserver } from '..'

function useHeightObserver({
  externalHeight,
  onChangeSize,
}: {
  externalHeight: number | undefined
  onChangeSize?: (height: number) => void
}) {
  const localRef = useRef<HTMLDivElement>(null)
  const heightRef = useRef<number | null>(null)

  if (typeof externalHeight === 'number') heightRef.current = externalHeight

  const handleSizeChange = useCallback(
    (observedHeight: number | undefined) => {
      if (!onChangeSize || !observedHeight) return

      const roundedHeight = Math.round(observedHeight)
      if (typeof heightRef.current === 'number' && heightRef.current > 0 && roundedHeight !== heightRef.current) {
        onChangeSize(roundedHeight)
        heightRef.current = roundedHeight
      }
    },
    [onChangeSize]
  )

  useResizeObserver({
    ref: localRef,
    box: 'border-box',
    onResize: ({ height }) => handleSizeChange(height),
  })

  return localRef
}

export default useHeightObserver
